define((require, exports, module) => {
    'use strict';

    const env = require('../env');
    const normalizeToNfc = require('../string/normalizeToNfc');

    /**
     * @type namespace
     */
    const fileSystemPath = {
        /**
         * .DS_Store – парамтеры отображения директории в macOS
         * Desktop.ini – парамтеры отображения директории в Windows
         * Thumbs.db – эскизы изображений в Windows
         * ehthumbs.db – эскизы видеофайлов в Windows
         *
         * @type {RegExp}
         */
        ignoredFileNames: /^(\.DS_Store|Desktop\.ini|Thumbs\.db|ehthumbs\.db)$/,

        /**
         * @param {string} name
         * @returns {boolean}
         */
        isIgnoredFileName(name) {
            return fileSystemPath.ignoredFileNames.test(name);
        },

        normalize(path) {
            // macOS использует Unicode NFD в именах файлов и папок,
            // а наш сервер преобразует все имена в NFC.
            // Нормальзуем локальные имена и пути в NFC,
            // чтобы избежать ошибок при сравнении строк.
            return normalizeToNfc(path);
        },

        /**
         * @param {string} path
         * @returns {string}
         */
        getVisiblePath(path) {
            let result = path;

            if (env.isMacOS) {
                // Finder в macOS отображает пользователю в имени файла слэш,
                // но в браузер попадает строка, в которой слэш заменен на двоеточие.
                // Создать файл с двоеточием в имени в macOS невозможно.
                // Будем использовать символ, который видит пользователь.
                result = result.replace(/:/g, '/');
            }

            return result;
        },

        /**
         * @param {string} path
         * @returns {Object}
         */
        getFullName(path) {
            const lastChar = path.slice(-1);
            let name;

            if (lastChar === '/') {
                name = path.slice(0, -1);
            } else {
                name = path;
            }

            const lastIndex = name.lastIndexOf('/');

            if (lastIndex !== -1) {
                name = name.slice(lastIndex + 1);
            }

            return name;
        },

        /**
         * @param {string} path
         * @returns {Object}
         */
        getNameParts(path) {
            const urlComponents = {
                name: '',
                extension: '',
            };

            const fullName = fileSystemPath.getFullName(path);
            const lastIndex = fullName.lastIndexOf('.');

            if (lastIndex > 0) {
                urlComponents.name = fullName.slice(0, lastIndex);
                urlComponents.extension = fullName.slice(lastIndex + 1);
            } else {
                urlComponents.name = fullName;
                urlComponents.extension = '';
            }

            return urlComponents;
        },

        /**
         * @param {string} path
         * @returns {Object}
         */
        getVisibleNameParts(path) {
            const urlComponents = fileSystemPath.getNameParts(path);
            const name = urlComponents.name;
            const extension = urlComponents.extension;

            if (name) {
                urlComponents.name = fileSystemPath.getVisiblePath(name);
            }

            if (extension) {
                urlComponents.extension = fileSystemPath.getVisiblePath(
                    extension,
                );
            }

            return urlComponents;
        },

        join() {
            // eslint-disable-next-line prefer-rest-params
            let path = arguments[0] || '';

            for (let i = 1; i < arguments.length; i++) {
                // eslint-disable-next-line prefer-rest-params
                const pathPart = arguments[i];

                if (pathPart) {
                    const pathEndsWithSlash =
                        path.charAt(path.length - 1) === '/';
                    const pathPartStartsWithSlash = pathPart.charAt(0) === '/';

                    if (pathEndsWithSlash && pathPartStartsWithSlash) {
                        path = path + pathPart.substring(1);
                    } else if (!pathEndsWithSlash && !pathPartStartsWithSlash) {
                        path = path + '/' + pathPart;
                    } else {
                        path = path + pathPart;
                    }
                }
            }

            return path;
        },
    };

    module.exports = fileSystemPath;
});
